import {
  SAVE_ALL_FOM_MASTIC,
  ACTION_GET_FOM_RELATION,
  FOM_MASTIC_SEARCH,
} from "Stores/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  fomMastikData: [],
  dataRelationFomMastik: [],
  fomMastikDataPagination:{Limit: 10, Page: 1, Total: 0 },
  fomMastikDataSearch: null,

};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_ALL_FOM_MASTIC:
      return updateObject(state, {
        fomMastikData: action.fomMastikData,
        fomMastikDataPagination: action.fomMastikDataPagination,
      });
      case FOM_MASTIC_SEARCH:
        return updateObject(state, {
          fomMastikDataSearch: action.fomMastikDataSearch,
        });
    case ACTION_GET_FOM_RELATION:
      return updateObject(state, {
        dataRelationFomMastik: action.dataRelationFomMastik,
      });

    default:
      return state;
  }
};

export default reducer;
